import * as THREE from "three";

export const boxGeometry = new THREE.BoxGeometry(1, 1, 1);